import { gql } from "@apollo/client";

const REPORT_QUERY = {
  GET_REPORT: gql`
    query getOneReport($reportId: String!) {
      getOneReport(reportId: $reportId) {
        reportId
        chatRoomId
        clipId
        clipType
        createdOn
        id
        otherText
        ownerId
        reason
        uid
        reportsCount
        status
        reportee {
          uid
          userType
          email
          displayName
          createdOn
          status
          userProfile {
            firstName
            lastName
            isActive
          }
        }
        reporter {
          uid
          userType
          email
          displayName
          createdOn
          status
          userProfile {
            firstName
            lastName
            isActive
          }
        }
      }
    }
  `,
  GET_USER_REPORT: gql`
    query getUserReportDetails($reportId: String!) {
      getUserReportDetails(reportId: $reportId) {
        reportId
        chatRoomId
        clipId
        clipType
        createdOn
        id
        otherText
        ownerId
        reason
        uid
        reportsCount
        status
        reportee {
          uid
          userType
          email
          displayName
          profileImage
          status
          userProfile {
            firstName
            lastName
            isActive
            phoneNumber {
              phNumber
              phoneCode
            }
          }
        }
        reporter {
          uid
          userType
          email
          displayName
          profileImage
          status
          userProfile {
            firstName
            lastName
            isActive
            phoneNumber {
              phNumber
              phoneCode
            }
          }
        }
      }
    }
  `,
  GET_REPORTED_CLIP: gql`
    query getReportedClip($reportId: String!) {
      getReportedClip(reportId: $reportId) {
        id
        medias {
          mediaLabel
          mediaPath
          mediaSize
          mediaThumb
          mediaType
          thumbnail
          mediafile
        }
        mediafile
        text
        isArchived
        uid
        updatedOn
        createdOn
        publishedOn
        titles {
          clipId
          clipType
          createdOn
          profileId
          titleId
          uid
          updatedOn
        }
      }
    }
  `,

  GET_REPORTS: gql`
    query reportsList(
      $page: Int!
      $limit: Int!
      $searchQuery: String
      $ownerType: String
      $order: SortOrderEnum!
      $column: ReportsSortColumnsEnum!
    ) {
      reportsList(
        page: $page
        limit: $limit
        searchQuery: $searchQuery
        ownerType: $ownerType
        sortBy: { order: $order, column: $column }
      ) {
        list {
          reportId
          chatRoomId
          clipId
          clipType
          id
          reportee {
            uid
            userType
            email
            displayName
            createdOn
            status
            userProfile {
              firstName
              lastName
              isActive
            }
          }
          reporter {
            uid
            userType
            email
            displayName
            createdOn
            status
            userProfile {
              firstName
              lastName
              isActive
            }
          }
          otherText
          ownerId
          ownerType
          reason
          uid
          reportsCount
          status
          createdOn
        }
        totalCount
        limit
      }
    }
  `,
  GET_USER_REPORTS: gql`
    query userReportsList(
      $page: Int!
      $limit: Int!
      $searchQuery: String
      $userType: String
      $order: SortOrderEnum!
      $column: UserReportsSortColumnsEnum!
    ) {
      userReportsList(
        page: $page
        limit: $limit
        searchQuery: $searchQuery
        userType: $userType
        sortBy: { order: $order, column: $column }
      ) {
        list {
          reportId
          id
          otherText
          reason
          reporteeDisplayName
          reporteeId
          reporteeEmail
          reporteeType
          reporterDisplayName
          reporterId
          reportCount
          status  
          createdOn
        }
      page
      limit 
      totalCount
      totalPages
      }
    }
  `,

  GET_WEEKLY_RESPONSE_TIME: gql`
    {
      getWeeklyAvgResponseTime {
        days
        hours
        minutes
        seconds
      }
    }
  `,
  GET_USER_REPORTS_WEEKLY_RESPONSE_TIME: gql`
    {
      getWeeklyAvgResponseTime {
        days
        hours
        minutes
        seconds
      }
    }
  `,
  EXPORT_CSV: gql`
    query exportReports($from: String, $to: String) {
      exportReports(from: $from, to: $to) {
        reportId
        reporteeHistory
        reportee {
          uid
          displayName
        }
        clipType
        reportsCount
        lastActionAt
        lastActionBy
        lastActionByUser {
          uid
          email
          displayName
          userProfile {
            firstName
            lastName
          }
        }
        reporter {
          uid
          displayName
        }
        createdOn
        reason
        otherText
        clipLocation
        status
      }
    }
  `,
  REPORT_STATUS_ACTION: gql`
    mutation ($reportId: String!, $status: ReportStatusEnum!) {
      updateReportStatus(reportId: $reportId, status: $status) {
        status
      }
    }
  `,
  REPORT_USER_STATUS_ACTION: gql`
    mutation ($reportId: String!, $status: ReportStatusEnum!) {
      updateUserReportStatus(reportId: $reportId, status: $status) {
        status
      }
    }
  `,
  GET_ACTIVITY_LOG: gql`
    query activityLogsList($page: Int!, $clipId: String!) {
      activityLogsList(page: $page, clipId: $clipId, limit: 10) {
        list {
          action
          createdOn
          metaData
          reportId
        }
        page
        limit
        totalCount
      }
    }
  `,
  GET_USER_REPORT_ACTIVITY_LOG: gql`
    query activityLogsList($page: Int!, $reportId: String!) {
      activityLogsList(page: $page, reportId: $reportId, limit: 10) {
        list {
          action
          createdOn
          metaData
          reportId
        }
        page
        limit
        totalCount
      }
    }
  `,
  GET_REASONS: gql`
    query reasonsList($page: Int!) {
      reasonsList(page: $page) {
        list {
          id
          title
          status
        }
        page
        limit
      }
    }
  `,

  CREATE_REASON: gql`
    mutation createReason($title: String!) {
      createReason(data: { title: $title })
    }
  `,

  DELETE_REASON: gql`
    mutation ($id: String!) {
      removeReason(id: $id)
    }
  `,
};
export default REPORT_QUERY;
